import type { LayoutChangeEvent } from "react-native";

import { LoyaltyIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

type RewardPointsPillProps = {
  points: number;
  isAvailable: boolean;
  width: number | undefined;
  onLayout: (event: LayoutChangeEvent) => void;
};

export const RewardPointsPill = ({
  points,
  isAvailable,
  width,
  onLayout,
}: RewardPointsPillProps) => (
  <HStack
    onLayout={onLayout}
    alignItems="center"
    justifyContent="center"
    alignSelf="flex-start"
    gap={2}
    width={width}
    px={4}
    py={1}
    borderWidth={isAvailable ? 0 : 1}
    borderColor={isAvailable ? undefined : "surface-accent-purple-subtle"}
    backgroundColor={
      isAvailable ? "surface-accent-purple-subtlest" : "surface-primary"
    }
    style={{ borderRadius: 100 }}
  >
    <Text
      variant="mainSmallSemiBold"
      color={isAvailable ? "text-primary" : "text-accent-purple-primary"}
    >
      {points}
    </Text>
    <LoyaltyIcon
      color={isAvailable ? "icon-primary" : "text-accent-purple-primary"}
      width={16}
      height={16}
    />
  </HStack>
);
